<template>
          <v-dialog v-model="showConfirm" persistent max-width="500">
          <v-card>
            <v-card-title class="headline" style="font-family: 'Poppins', sans-serif !important;">{{title}}</v-card-title>
            <v-card-text>{{message}}</v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="#FFFFFF" text @click="doConfirm" style="background-color: #000000; border-radius: 30px; padding: 0 10px;">{{titleOk}}</v-btn>
              <v-btn v-if="!!titleCancel" text @click="doCancel" style="border-radius: 30px; padding: 0 10px;">{{titleCancel}}</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
</template>

<script>
 
  export default {
    name: 'ConfirmDialog', 
    props: ['message','titleOk','titleCancel','title'],
    data(){
        return { 
             payload:null,
             showConfirm: false
        }

    },  
    methods: {
        confirm(payload)
        { 
            this.payload=payload;
            this.showConfirm=true;
        }
        ,
        doConfirm()
        {
            this.showConfirm = false;
            this.$emit('confirmed',this.payload);
        },
        doCancel()
        {
            this.showConfirm = false;
            this.$emit('canceled',this.payload);
        }
      },
  }
</script>